const getPrimaryEvent = (state) => state.primaryEvent
const getPrimaryEventData = (state) => state.primaryEvent.data

export default {
  getPrimaryEvent,
  getPrimaryEventData
}
